<template>
  <div class="row">
    <div class="col-md-12">

      <div class="dro-settings row  mt-3" v-if="!isIntervalStarted && isLoaded">
        <div class="col-sm-6 col-md-4">
          <h5 class="title">{{'dro.interval_duration_units' | trans}}:</h5>
          <mdc-radio v-model="form.intervalDurationUnitId"
                     name="intervalDurationUnitId"
                     :label="'dro.min' | trans" value="1"/>
          <mdc-radio v-model="form.intervalDurationUnitId"
                     name="intervalDurationUnitId"
                     :label="'dro.sec' | trans"
                     value="2"/>
        </div>

        <div class="col-sm-6 col-md-6">
          <h5 v-if="form.intervalDurationUnitId == 1" class="title">
            {{'dro.interval_time_range_minutes' |
            trans}}:</h5>
          <h5 v-else-if="form.intervalDurationUnitId == 2" class="title">
            {{'dro.interval_time_range_seconds' |
            trans}}:</h5>
          <h5 v-else class="title">{{'dro.interval_time_range' | trans}}:</h5>
          <mdc-textfield v-if="form.intervalDurationUnitId == 1"
                         v-model="form.intervalDurationValue"
                         name="intervalDurationValue"
                         v-validate="'required|numeric|min_value:1|max_value:100'"
                         :class="{'is-invalid': errors.has('intervalDurationValue')}"
                         type="number"
                         min="1"
                         max="100"
                         data-vv-validate-on="none"
                         :data-vv-as="'validation.attributes.report.intervalDurationValue' | trans"/>
          <mdc-textfield v-if="form.intervalDurationUnitId == 2"
                         v-model="form.intervalDurationValue"
                         name="intervalDurationValue"
                         v-validate="'required|numeric|min_value:1|max_value:300'"
                         :class="{'is-invalid': errors.has('intervalDurationValue')}"
                         type="number"
                         min="1"
                         max="300"
                         data-vv-validate-on="none"
                         :data-vv-as="'validation.attributes.report.intervalDurationValue' | trans"/>
          <span class="invalid-feedback"
                v-if="errors.has('intervalDurationValue')">
                                            {{ errors.first('intervalDurationValue') }}
                                        </span>
          <label v-if="form.intervalDurationUnitId == 1">{{'dro.min' |
            trans}}</label>
          <label v-else-if="form.intervalDurationUnitId == 2">{{'dro.sec' |
            trans}}</label>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <interval-progress-bar></interval-progress-bar>
        </div>
      </div>


      <div class="dro-settings row mt-5">

        <div class="col-md-12 text-center" v-if="isIntervalStarted">
          <mdc-button type="submit"
                      class="button-success text-uppercase col-sm-6 mb-3"
                      @click="onBehaviourHappened()"
                      @keyup.32="clickPrevent"
                      v-if="isIntervalStarted">{{'dro.target_behaviour' |
            trans}}
          </mdc-button>
        </div>
        <div class="col-md-12 text-center" v-if="isIntervalStarted">
          <mdc-button type="submit"
                      class="button-warning text-uppercase col-sm-6 mt-2"
                      @click="finishSession()"
                      @keyup.32="clickPrevent"
                      v-if="isIntervalStarted">{{'dro.finish_session' | trans}}
          </mdc-button>
        </div>
        <div class="col-md-12 text-center" v-if="!isIntervalStarted">
          <mdc-button type="submit"
                      class="button-success text-uppercase col-sm-6 text-uppercase mb-3"
                      @click="startSession()"
                      @keyup.32="clickPrevent"
                      v-if="!isIntervalStarted">{{'dro.continue_session' |
            trans}}
          </mdc-button>
        </div>
        <div class="col-md-12 text-center" v-if="!isIntervalStarted">
          <mdc-button type="submit"
                      class="button-warning text-uppercase col-sm-6 mt-2"
                      @click="saveSession()"
                      @keyup.32="clickPrevent"
                      v-if="!isIntervalStarted">{{'dro.finish_session' | trans}}
          </mdc-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import {currentIntervalForm} from '../../../mixins/currentIntervalForm';

  export default {

    mixins: [currentIntervalForm],

    created() {
      this.fillFormData();
      this.init();
    },
    methods: {
      clickPrevent (e) {
        e.preventDefault();
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/dro/components/CurrentIntervalForm.vue